import { initializeApp, getApps } from 'firebase/app';

const requiredKeys = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_APP_ID'
];
let cachedApp = null;
let configCache = null;
let missingKeys = null;

function getEnv(key) {
  return (window._env_ && window._env_[key]) || process.env[key];
}

function buildConfig() {
  if (configCache) {
    return configCache;
  }

  configCache = {
    apiKey: getEnv('REACT_APP_FIREBASE_API_KEY'),
    authDomain: getEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    projectId: getEnv('REACT_APP_FIREBASE_PROJECT_ID'),
    appId: getEnv('REACT_APP_FIREBASE_APP_ID'),
    storageBucket: getEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID')
  };

  missingKeys = requiredKeys.filter((key) => !getEnv(key));
  return configCache;
}

export function isFirebaseConfigured() {
  buildConfig();
  return missingKeys.length === 0;
}

export function getFirebaseConfig() {
  return buildConfig();
}

export function initFirebaseApp() {
  if (cachedApp) {
    return cachedApp;
  }

  if (!isFirebaseConfigured()) {
    console.warn('Firebase environment variables missing:', missingKeys.join(', '));
    return null;
  }

  const apps = getApps();
  cachedApp = apps.length > 0 ? apps[0] : initializeApp(getFirebaseConfig());
  return cachedApp;
}
